import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'simplebar-react/dist/simplebar.min.css';
import 'assets/third-party/react-table.css';
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';

// The backend's invitation and password-reset emails link to
// `${PARTNER_PORTAL_URL}/#/partner/accept-invitation?token=…` (hash routes, written for
// the customer app). This app routes by path, so turn such a link into
// `/accept-invitation?token=…` before the router reads the URL.
const { hash } = window.location;
if (hash.startsWith('#/')) {
  const path = hash.slice(1).replace(/^\/partner(?=\/|\?|$)/, '') || '/';
  window.history.replaceState(null, '', path.startsWith('/') ? path : `/${path}`);
}

const container = document.getElementById('root');

if (container) {
  createRoot(container).render(
    <ConfigProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  );
}
